module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.bdb50b32.webp";